/* global jQuery COMPONENTS */

COMPONENTS.ComponentHero = (function ($) {
  function ComponentHero () {
    this.$component = $('[data-ecs-component="component-hero"]')

    // Video variables
    this.$plyrElem = this.$component.find('[data-ecs-components-control="hero-plyr"]')
    this.$plyrParent = this.$component.find('.ecs_hero_video')
    this.videoSettings = {}
    this.videoSettings.load = {}
    if (this.$plyrParent.length > 0) {
      if (typeof this.$plyrParent.attr('data-ecs-plyr-controls') != 'undefined') {
        this.videoSettings.controls = this.$plyrParent.attr('data-ecs-plyr-controls').split(', ')
      }
      this.videoSettings.load.play = this.$plyrParent[0].hasAttribute('data-ecs-plyr-load-play')
      this.videoSettings.load.mute = this.$plyrParent[0].hasAttribute('data-ecs-plyr-load-mute')
      this.videoSettings.load.cc = this.$plyrParent[0].hasAttribute('data-ecs-plyr-load-cc')
      this.videoSettings.load.mobile = this.$plyrParent[0].hasAttribute('data-ecs-plyr-load-on-mobile')
    }
    
    if (this.$plyrElem) {
      this.videoSettings.aspectRatio = ''
      if (typeof this.$plyrElem.attr('data-ecs-aspect-ratio') !== 'undefined' && this.$plyrElem.attr('data-ecs-aspect-ratio') !== false) {
        this.videoSettings.aspectRatio = this.$plyrElem.attr('data-ecs-aspect-ratio')
      }
    }

    // Slider Variables
    this.$sliderElem = this.$component.find('[data-ecs-components-control="hero-slider"]')
    this.$introSliderElem = this.$component.find('[data-ecs-components-control="hero-slider-intro"]')
    if (this.$sliderElem || this.$introSliderElem) {
      const utility = new COMPONENTS.Utility()
      this.slidesToDisplay = 1
      this.sliderVars = utility.getSliderVars(this.slidesToDisplay)
    }

    // Quick Search Variables
    this.$marketSearch = this.$component.find('[data-ecs-element="hero-market-search"]')
    this.$marketSearchSubmit = this.$marketSearch.find('[data-ecs-components-control="submit"]')
    this.$quickNeighborhoodSelect = this.$marketSearch.find('[data-ecs-neighborhood-select]')
    this.$quickMarketSelect = this.$marketSearch.find('[data-ecs-market-select]')

    this.videoInitialized = false
  }

  ComponentHero.prototype.initSlider = function () {
    const utility = new COMPONENTS.Utility()
    if (this.$sliderElem.length) {
      this.$sliderElem.slick(this.sliderVars)
      utility.bindSliderAriaSelected(this.$sliderElem)
    }
    if (this.$introSliderElem.length) {
      this.$introSliderElem.slick(this.sliderVars)
      utility.bindSliderAriaSelected(this.$introSliderElem)
    }
  }

  ComponentHero.prototype.initVideo = function () {
    const component = this
    var plyrSettings = {
      autopause: false,
      autoplay: component.videoSettings.load.play,
      captions: {
        active: component.videoSettings.load.cc,
        language: 'auto',
        update: false
      },
      clickToPlay: true,
      controls: component.videoSettings.controls,
      fullscreen: {
        enabled: false,
        fallback: true,
        iosNative: false
      },
      hideControls: false,
      keyboard: {
        focused: true,
        global: false
      },
      loadSprite: true,
      loop: {
        active: true
      },
      muted: component.videoSettings.load.mute,
      volume: 0,
      ratio: component.videoSettings.aspectRatio,
      tooltips: {
        controls: false,
        seek: true
      },
      vimeo: {
        autoplay: component.videoSettings.load.play,
        controls: true,
        loop: true,
        muted: component.videoSettings.load.mute,
        portrait: false,
        texttrack: '',
        title: false,
        cc: component.videoSettings.load.cc
      },
      youtube: {
        autoplay: 1,
        controls: 1,
        disablekb: 0, // keyboard controls
        fs: 0, // fullscreen
        loop: 1,
        modestbranding: 1,
        cc_load_policy: + component.videoSettings.load.cc
      }
    }

    if (plyr_required) {
      if (component.$plyrElem.length >= 1) {
        component.plyr = new Plyr(component.$plyrElem, plyrSettings)
        if (component.videoSettings.load.play != false) {
          component.plyr.on('ready', () => {
            component.plyr.muted = true
            component.plyr.play()
          })
        }

        component.plyr.on('playing', () => {
          component.$component.find('.ecs_hero_video').addClass('ecs_plyr_loaded')
        })
      }
    }
  }

  ComponentHero.prototype.setAction = function () {
    const component = this
    const defaultAction = component.$marketSearch.data('ecs-market-slug')

    let marketAction = false
    if (component.$marketSearch.attr('data-ecs-market-action') != undefined) {
      marketAction = component.$marketSearch.data('ecs-market-action')
    }

    let neighborhoodAction = false
    if (component.$marketSearch.attr('data-ecs-neighborhood-action') != undefined) {
      neighborhoodAction = component.$marketSearch.data('ecs-neighborhood-action')
    }

    const marketActionMode = component.$marketSearch.data('ecs-action-mode')
    const marketValue = component.$quickMarketSelect.val()
    const marketUrl = function () {
      if (marketActionMode == 'custom') {
        return marketAction
      } else {
        return (marketAction + marketValue)
      }
    }

    const neighborhoodActionMode = component.$quickNeighborhoodSelect.data('ecs-action-mode')
    const neighborhoodValue = component.$quickNeighborhoodSelect.val()
    const neighborhoodUrl = function () {
      if (neighborhoodActionMode == 'custom') {
        return neighborhoodAction
      } else {
        return (neighborhoodAction + neighborhoodValue)
      }
    }

    const nullValues = ['*', 'all-communities']

    if (marketAction != false && neighborhoodAction != false) {
      if (!nullValues.includes(marketValue) && !nullValues.includes(neighborhoodValue)) {
        // Both values are populated, set ACTION to DEFAULT
        component.$marketSearch.attr('action', defaultAction)
      } else if (!nullValues.includes(marketValue) || !nullValues.includes(neighborhoodValue)) {
        // One of the values is populated, set ACTION to POPULATED VALUE or CUSTOM PAGE
        if (!nullValues.includes(marketValue)) {
          // Market search is populated
          component.$marketSearch.attr('action', marketUrl)
        } else if (!nullValues.includes(neighborhoodValue)) {
          // Neighborhood search is populated
          component.$marketSearch.attr('action', neighborhoodUrl)
        }
      } else {
        // Both values have returned to default, set ACTION to DEFAULT
        component.$marketSearch.attr('action', defaultAction)
      }
    } else if (marketAction != false || neighborhoodAction != false) {
      if (marketValue !== undefined && !nullValues.includes(marketValue)) {
        component.$marketSearch.attr('action', marketUrl)
      } else if (neighborhoodValue !== undefined && !nullValues.includes(neighborhoodValue)) {
        component.$marketSearch.attr('action', neighborhoodUrl)
      } else {
        component.$marketSearch.attr('action', defaultAction)
      }
    }
  }

  ComponentHero.prototype.init = function () {
    const component = this
    const windowMobile = window.matchMedia('(min-width: 768px)')

    // Check viewport width before loading Sliders
    if (windowMobile.matches) {
      component.initSlider()
    }

    // Check viewport width OR if video on mobile load is enabled before loading Video
    if (windowMobile.matches || this.videoSettings.load.mobile) {
      if (typeof ecs_cookie_consent_active !== 'undefined' && ecs_cookie_consent_active) {
        // Plyr with Vimeo makes connections that set Vimeo cookies on init.
        // Defer until the user grants analytics consent. The fallback static
        // background image already renders in the DOM and remains visible.
        document.addEventListener('ecsCookieAccept', function () {
          if (!component.videoInitialized) {
            component.videoInitialized = true
            component.initVideo()
          }
        })
        // For returning users whose consent is detected on page load via ecsCookieCheck
        document.addEventListener('ecsCookieCheck', function (e) {
          var cats = e.detail && e.detail.cookie && e.detail.cookie.categories
          if (cats && cats.length >= 2 && !cats.every(function (c) { return c === 'necessary' })) {
            if (!component.videoInitialized) {
              component.videoInitialized = true
              component.initVideo()
            }
          }
        })
      } else {
        component.initVideo()
      }
    }

    component.$quickNeighborhoodSelect.change(function () {
      component.setAction()
    })
    component.$quickMarketSelect.change(function () {
      component.setAction()
    })
  }

  return ComponentHero
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.ComponentHero = new COMPONENTS.ComponentHero()
  COMPONENTS.ComponentHero.init()
})
